export default __webpack_public_path__ + "static/51-94fb849774bf5b627c0b964f4b484fd5.png";